<template>
  <vue-modal
    :delay="100"
    :classes="[
      'generic-modals',
      'v--modal',
      'feature-tab-modal'
    ]"
    name="featureTabModal"
    width="70%"
    height="auto"
    :pivotY="0.3"
    @before-open="beforeOpen"
    @closed="closeModal"
  >
    <section class="feature-tab-modal__wrapper">
      <div class="feature-tab-modal__inner">
        <h2 class="feature-tab-modal__title feature-title">
          {{ featureTab.title }}
        </h2>
        <div class="feature-tab-modal__body">
          <img
            v-if="featureTab.imageUrl"
            :src="`${imgSrcUrl}`"
            :alt="featureTab.title"
            class="feature-tab-modal__img"
          >
          <p class="feature-tab-modal__description">{{ featureTab.description }}</p>
        </div>
      </div>
      <div slot="top-right">
        <button type="button" class="close-button" title="Close" @click="exit">
          <span class="icon-close"></span>
        </button>
      </div>
    </section>
  </vue-modal>
</template>

<script>

export default {
  name: "featureTabModal",
  data() {
    return {
      isLoadingData: true,
      showCloseIcon: true,
      featureTab: {}
    }
  },
  computed: {
    assetsPath() {
      return this.$store.state.endPoints.customizer.customsAssets;
    }
  },
  watch: {
    showSpinner(show) {
      this.$refs.spinner.hideSpinner(!show);
    }
  },
  methods: {
    beforeOpen(event) {
      this.featureTab = event.params.featureTab;
      this.imgSrcUrl = `${this.assetsPath}${this.featureTab.imageUrl}`;
    },

    closeModal() {
      this.featureTab = {};
    },
    exit() {
      this.$modal.hide('featureTabModal');
    }
  }
}
</script>